function Footer() {
    return (
        <div>
            <div className="space" />

            <footer className="container justify-center b-bg">
                <div className="container nowrap align-center">
                    <small>
                        <a href="#" className="link nowrap threepercent-lr-margin">Politique de confidentialité</a>
                    </small>
                    <h2 className="logo-title">Company</h2>
                </div>
            </footer>
        </div>
    )
}

export default Footer;